module.exports = __webpack_public_path__ + "img/file-type-doc.21906e53.svg";